import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";
import { Options } from "select2";

export class CoatingTypeFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;

    controller: FiltersController;
    parentGroup: FilterGroup;
    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'coatingType';
        this.name = 'Type de matériaux';
        this.type = 'coatingType';

        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>${this.name}</span>
            <select id="coatingTypeInput" style="width: 100%;" title="${this.name}"></select>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadCoatingTypes().then(() => {
                if (this.parentGroup.isDestroyed) return;
                checkAndDestroySelect2('coatingTypeInput');
                let coatingObjects = FilterGroup.coatingTypes!.map((element) => {
                    return {
                        id: element._id || '-1',
                        text: element.name,
                        title: this.name,
                        selected: FilterGroup.filters.coatingType?.includes(element)
                    };
                })

                $('#coatingTypeInput').select2({
                    multiple: true,
                    placeholder: {
                        id: '-1',
                        text: 'Choisissez un type'
                    },
                    data: [
                        {
                            id: '-1',
                            text: 'Choisissez un type',
                        },
                        ...coatingObjects
                    ],
                    width: 'element',
                    matcher: globalMatcher,
                    templateResult: globalTemplateResult,
                    selectionCssClass: 'select-control',
                } as unknown as Options);

                $('#coatingTypeInput').on('change.select2', () => {
                    let selectedValues = $('#coatingTypeInput').val() as string[];
                    if (selectedValues.length === 0 || selectedValues[0] === '-1') {
                        FilterGroup.filters.coatingType = null;
                    } else {
                        FilterGroup.filters.coatingType = FilterGroup.coatingTypes!.filter((element) => selectedValues.includes(element._id)) || null;
                    }
                    FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
                });
            });
        });

        return html;
    }
    
    // Done
    generateStringFilter(): string {
        let stringFilters = "";

        if (FilterGroup.filters.coatingType !== null && FilterGroup.filters.coatingType.length > 0) {
            stringFilters += '&q.coatingType.in='; //TODO: check if this is correct
            for (let i = 0; i < FilterGroup.filters.coatingType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += FilterGroup.filters.coatingType[i]._id;
            }
        }

        return(stringFilters);
    }

    destroy(): void {
        $('#coatingTypeInput').off('change.select2');
        checkAndDestroySelect2('coatingTypeInput');
        this.controller.destroy();
    }
}